
<!-- UNIFIED SEARCH (new) -->
<div *ngIf="unifiedSearch">

  <div style="width: 580px">
    <label for="unisearch">Search</label>
    <!-- <app-ui-search id="unisearch" [searchables]="['Customer Name','Policy Number','Customer Email','Customer Phone','Customer First Name']" (searchEmit)="searchedFor($event)"></app-ui-search> -->
  </div>

  <!-- TABLE -->
  <div class="d-b p-t-30">
    <nz-table #nestedTable [nzData]="nestedTableData" [nzPageSize]="10" [nzLoading]="isLoading">
      <thead>
      <tr>
        <th nzShowExpand></th>
        <th>Name</th>
        <th>Product</th>
        <th>Policy No</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Expiry</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <ng-template ngFor let-data [ngForOf]="nestedTable.data">
        <tr>
          <td nzShowExpand [(nzExpand)]="data.expand"></td>
          <td>{{data.name}}</td>
          <td>{{data.product}}</td>
          <td>{{data.policy}}</td>
          <td>{{data.email}}</td>
          <td>{{data.phone}}</td>
          <td>{{data.expiry}}</td>
          <td>
            <a>Select</a>
          </td>
        </tr>
        <tr [nzExpand]="data.expand">
          <td></td>
          <td colspan="100" class="nested-table"  style="background-color: #f8f8f8">
            <h6 class="p-b-5">Linked Policies</h6>
            <ng-container *ngTemplateOutlet="innerTable; context: data"></ng-container>
          </td>
        </tr>
    </ng-template>
    </tbody>
    </nz-table>
  </div>

</div><!-- unifiedSearch -->



<ng-template #innerTable>
  <nz-table [nzData]="innerTableData" nzSize="small" [nzShowPagination]="false" [nzLoading]="false" [nzFooter]="null">
    <thead>
    <tr>
      <th>Name</th>
      <th>Product</th>
      <th>Policy</th>
      <th>Expiry</th>
      <th>Status</th>
      <th>Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of innerTableData">
      <td>{{data.name}}</td>
      <td>{{data.product}}</td>
      <td>{{data.policy}}</td>
      <td>{{data.expiry}}</td>
      <td>
        <nz-badge [nzStatus]="'success'" [nzText]="'Active'"></nz-badge>
      </td>
      <td>
        <span class="table-operation">
          <a>Select</a>
        </span>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-template>



<!-- OLD SEARCH -- SEP TABS FOR SEARCH BY CUSTOMER AND SEARCH BY POLICY -->
<div *ngIf="!unifiedSearch">
  <!-- Search by ? -->
  <h3>Search by</h3>
  <nz-radio-group [(ngModel)]="searchCustOrPolicy" (ngModelChange)="searchCustOrPolicyChanged()" [nzButtonStyle]="'solid'" [nzSize]="'default'">
    <label nz-radio-button nzValue="customer">
      <i nz-icon nzType="user" nzTheme="outline"></i> Customer
    </label>
    <label nz-radio-button nzValue="policy">
      <i nz-icon nzType="file-protect" nzTheme="outline"></i> Policy
    </label>
  </nz-radio-group>

  <div class="search-fields m-t-20">
    <!-- Customer Search -->
    <div *ngIf="searchCustOrPolicy=='customer'">
      <div class="tab-grid">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">First Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input value=""/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input value="Hemsworth"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Date of Birth</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker style="width:100%" [nzFormat]="'DD MMM YYYY'"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Gender</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch [ngModel]="'0'" style="width: 100%">
              <nz-option [nzLabel]="'Male'" [nzValue]="'0'"></nz-option>
              <nz-option [nzLabel]="'Female'" [nzValue]="'1'"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <!-- Policy Search -->
    <div *ngIf="searchCustOrPolicy=='policy'">
      <div class="tab-grid">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Policy Number</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input value="P9200199/JMSP" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Customer Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input value="Hemsworth" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Product</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch [ngModel]="'0'" style="width: 100%">
              <nz-option [nzLabel]="'StandardLife'" [nzValue]="'0'"></nz-option>
              <nz-option [nzLabel]="'EndureLife'" [nzValue]="'1'"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Member ID (For Group Policy)</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input value="" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div class="multisearch-grid">
      <div>
        <button nz-button nzType="default" (click)="searchCustOrPolicyChanged()">
          Search for {{searchCustOrPolicy | titlecase}}
        </button>
      </div>
      <div></div>
      <div></div>
    </div>
  </div>

  <div class="search-results m-t-20">
    <!-- Show Result Tables -->
    <nz-skeleton [nzAvatar]="false"
                 [nzActive]="true" [nzTitle]="true" [nzLoading]="searchCustOrPolicyLoading">
      <!-- Policy Search Results -->
      <div *ngIf="searchCustOrPolicy=='policy'">
        <nz-table [nzData]="dataSet" [nzShowPagination]="true">
          <thead>
          <tr>
            <th></th>
            <th>Policy No</th>
            <th>Product</th>
            <th>Customer Name</th>
            <th>Customer Phone</th>
            <th>Role</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><label nz-radio nzValue="A" [(ngModel)]="tmpPolicy"></label></td>
            <td><a (click)="policyPanel(1)">P9200199/JMSP</a></td>
            <td>StandardLife</td>
            <td>Chris Hemsworth</td>
            <td>9008902991</td>
            <td>Insured</td>
            <td>Issued</td>
          </tr>
          <tr>
            <td><label nz-radio nzValue="B" [ngModel]="false"></label></td>
            <td><a (click)="policyPanel(1)">P92899/PROLIF/JAN18</a></td>
            <td>StandardLife</td>
            <td>Chris Hemsworth</td>
            <td>9008902991</td>
            <td>Owner</td>
            <td>Issued</td>
          </tr>
          <tr>
            <td><label nz-radio nzValue="C" [ngModel]="false"></label></td>
            <td><a (click)="policyPanel(1)">P92UI8990/JUL18</a></td>
            <td>StandardLife</td>
            <td>Chris Hemsworth</td>
            <td>9008902991</td>
            <td>Owner</td>
            <td>Issued</td>
          </tr>
          </tbody>
        </nz-table>
      </div>
      <!-- Customer Search Results -->
      <div *ngIf="searchCustOrPolicy=='customer'">
        <nz-table [nzData]="dataSet" [nzShowPagination]="true">
          <thead>
          <tr>
            <th>Customer No</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>DOB</th>
            <th>Gender</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>C000593</td>
            <td>Chris</td>
            <td>Hemsworth</td>
            <td>17 Nov 1958</td>
            <td>M</td>
            <td><a (click)="viewAddCustomersPolicies('Chris Hemsworth (C000593)')">View & Add Policies</a></td>
          </tr>
          <tr>
            <td>C0010982</td>
            <td>Liam</td>
            <td>Hemsworth</td>
            <td>28 April 1978</td>
            <td>M</td>
            <td><a (click)="viewAddCustomersPolicies('Liam Hemsworth (C0010982)')">View & Add Policies</a></td>
          </tr>
          </tbody>
        </nz-table>
        <!-- Policies for selected customer -->
        <div *ngIf="showCustomerPolicies">
          <div class="heading-tab">
            <h3 class="heading">
              <i nz-icon nzType="file-text"></i> Polices for {{showCustomerPoliciesName}}
            </h3>
          </div>
          <nz-table [nzData]="dataSet" [nzShowPagination]="true">
            <thead>
            <tr>
              <th></th>
              <th>Policy No</th>
              <th>Product</th>
              <th>Customer Name</th>
              <th>Customer Phone</th>
              <th>Role</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><label nz-radio [nzValue]="'A'" [(ngModel)]="tmpPolicy"></label></td>
              <td>P9200199/JMSP</td>
              <td>StandardLife</td>
              <td>Chris Hemsworth</td>
              <td>9008902991</td>
              <td>Owner</td>
              <td>Issued</td>
            </tr>
            <tr>
              <td><label nz-radio [nzValue]="'B'" [ngModel]="false"></label></td>
              <td>P920069994/JMSP</td>
              <td>StandardLife</td>
              <td>Chris Hemsworth</td>
              <td>9008902991</td>
              <td>Insured</td>
              <td>Issued</td>
            </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </nz-skeleton>

  </div>

</div>
